import React, { memo, RefObject } from "react"

import { Message } from "@shared/hooks/useMessages"

import { PowerfulMessage } from "./messages"

interface Props {
  isActive?: boolean
  noticeRef?: RefObject<HTMLDivElement>
  className: string
  message?: Message
}

export default memo(function Notice({
  isActive,
  noticeRef,
  className,
  message,
}: Props) {
  if (!isActive || !message) {
    return null
  }

  return (
    <div className={className} ref={noticeRef}>
      <PowerfulMessage
        key={message.key}
        scrollMessages={() => {}}
        message={message}
      />
    </div>
  )
})
